import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';
//import { LocalStorage } from 'ngx-store';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  api: string = environment.apiUrl;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  @LocalStorage('loggedUser') loggedUser: any;

  constructor(private http: HttpClient) { }

  async createUser(data: any): Promise<any> {
    return this.http
      .post(`${this.api}/users`, data, { headers: this.headers })
      .toPromise();
  }

  async getUsers(): Promise<any> {
    return this.http
      .get(`${this.api}/users`, { headers: this.headers })
      .toPromise();
  }
  async resetPassword(data): Promise<any> {
    return this.http
      .post(`${this.api}/users/reset-password`, data, { headers: this.headers, responseType: 'text', observe: 'response' })
      .toPromise();
  }
  async askToReset(data): Promise<any> {
    return this.http
      .post(`${this.api}/users/forgot-password`, data, { headers: this.headers, responseType: 'text', observe: 'response' })
      .toPromise();
  }

  async blockUser(data): Promise<any> {
    const header = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return this.http
      .put(`${this.api}/users/block`, data, { headers: header, responseType: 'text', observe: 'response' })
      .toPromise();
  }

  async check_admin(): Promise<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
    return await this.http
        .get(this.api + `//users/checkAdmin`, {headers, observe: 'response'}).toPromise();
  }

  async get_notified_users(): Promise<any> {
    return this.http
      .get(`${this.api}/users/notifiedUsers`, {headers: this.headers , observe: 'response' })
      .toPromise();
  }
  async get_subject_id(): Promise<any> {
    return this.http
      .get(`${this.api}/users/subjectId`, {headers: this.headers , observe: 'response' })
      .toPromise();
  }
  async getFactorAnalysisData(): Promise<any> {
      return this.http
        .get(`${this.api}/users/faData`, {headers: this.headers , observe: 'response' })
        .toPromise();
    }
  async add_subject_id(data: any): Promise<any> {
    return this.http
      .post(`${this.api}/subjectIdAdd`, data, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  async get_users_get(): Promise<any> {
    return this.http
      .get(`${this.api}/users/usGet`, {headers: this.headers , observe: 'response' })
      .toPromise();
  }
  async get_admins(): Promise<any> {
    //const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
    return this.http
        .get(`${this.api}/users/admin`, {headers: this.headers , observe: 'response' })
        .toPromise();
  }
}
